import * as React from "react"
import { LucideIcon } from "lucide-react"

interface VerticalTableRow {
  key: string
  value: React.ReactNode
}

interface VerticalTableProps {
  title: string
  icon?: LucideIcon
  rows: VerticalTableRow[]
}

export function VerticalTable({ title, icon: Icon, rows }: VerticalTableProps) {
  return (
    <div>
      <h2 className="text-lg font-semibold mb-2 flex items-center">
        {Icon && <Icon className="h-5 w-5 mr-2 text-muted-foreground" />}
        {title}
      </h2>
      <div className="space-y-4">
        <dl className="grid grid-cols-2 gap-2 text-sm">
          {rows.map((row, rowIndex) => (
            <React.Fragment key={rowIndex}>
              <dt className="text-muted-foreground">{row.key}</dt>
              <dd className="font-medium">{row.value || 'N/A'}</dd>
            </React.Fragment>
          ))}
        </dl>
      </div>
    </div>
  )
}
